import { createStoreCreator } from 'lib/store'
import reducer from 'reports/tpm/reducers'

export default createStoreCreator(reducer)
